import { useState, useContext } from 'react'
import { ModalContext } from '../ModalContext'

import DragDropFileUpload from 'components/Files/DragDropFIleUpload'
import BrandColorButton from 'components/Buttons/BrandColorButton'

export default function FileImportModal() {

    const { modalData, HideModal } = useContext(ModalContext)

    const [fileData, setFileData] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const [errorText, setErrorText] = useState('')

    const OnActionButtonClicked = async () => {

        setIsLoading(true)
        
        await modalData.buttonAction(fileData)

        setIsLoading(false)
        
        HideModal()
    }

    return (
        <>
            <div className="text-center text-lg font-semibold leading-6 text-gray-900">{modalData.titleText}</div>

            <p className='text-sm text-gray-600'> {modalData.fileFormatDescriptionText} </p>

            {modalData.exampleFileObject}

            <DragDropFileUpload 
                acceptedFileType=".csv"
                maxSizeMB={5}
                fileData={fileData}
                setFileData={setFileData}
                setErrorText={setErrorText}
            />

            {errorText !== '' && <p className="text-sm text-red-600">{errorText}</p>}

            <BrandColorButton
                text={modalData.buttonText}
                action={OnActionButtonClicked}
                isLoading={isLoading}
            />
        </>
    )
}
